import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 460px), 1fr));
  gap: 28px;
`;

export const Panel = styled.div<{ tone: 'before' | 'after' }>`
  border-radius: 34px;
  padding: 34px;
  border: 1px solid
    ${props =>
      props.tone === 'after' ? colors.borderHighlight : colors.border};
  background: ${props =>
    props.tone === 'after'
      ? `linear-gradient(180deg, ${colors.surfaceHighlight} 0%, ${colors.surface} 100%)`
      : colors.surfaceSunken};
`;

export const Eyebrow = styled.div<{ tone: 'before' | 'after' }>`
  font-family: ${typography.monoFontFamily};
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${props =>
    props.tone === 'after' ? colors.primary : colors.textFaintest};
`;

export const PanelHeading = styled.h3`
  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: 27px;
  line-height: 1.25;
  margin: 12px 0 28px;
  color: ${colors.textPrimary};
`;

export const List = styled.div`
  display: grid;
  gap: 22px;
`;

export const ListItem = styled.div`
  display: grid;
  grid-template-columns: 26px 1fr;
  gap: 14px;
  align-items: start;
`;

export const Bullet = styled.div<{ tone: 'before' | 'after' }>`
  width: 26px;
  height: 26px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: ${props => (props.tone === 'after' ? '14px' : '15px')};

  background: ${props =>
    props.tone === 'after' ? colors.primary : colors.dangerBg};
  color: ${props =>
    props.tone === 'after' ? colors.onPrimary : colors.danger};
`;

export const ItemTitle = styled.div`
  font-family: ${typography.displayFontFamily};
  font-weight: 600;
  font-size: 17px;
  color: ${colors.textPrimary};
`;

export const ItemDescription = styled.p<{ tone: 'before' | 'after' }>`
  margin: 6px 0 0;
  font-size: 15px;
  line-height: 1.6;
  color: ${props =>
    props.tone === 'after' ? colors.textSecondary : colors.textMuted};
`;

export const ResultCallout = styled.div`
  margin-top: 28px;
  border-radius: 28px;
  border-left: 4px solid ${colors.warning};
  background: ${colors.surface};
  padding: 28px 32px;

  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: baseline;
`;

export const ResultLabel = styled.span`
  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: 18px;
  color: ${colors.warning};
`;

export const ResultText = styled.span`
  font-size: 17px;
  line-height: 1.6;
  color: ${colors.textSecondary};
  flex: 1 1 300px;
  text-wrap: pretty;
`;
